//1.导入vue和router包
import Vue from 'vue'
import VueRouter from 'vue-router'
import { defaultRoutes } from './maps'

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
}
 
//2.调用Vue.use()函数，把 VueRouter 安装为 Vue 的插件
Vue.use(VueRouter)
 
//3.创建路由的示例对象
const router = new VueRouter({
  mode: 'hash',
  routes: [
    ...defaultRoutes,
  ]
})

export function resetRouter (router) {
  const newRouter = new VueRouter({
    mode: 'hash',
    routes: [
      ...defaultRoutes,
    ]
  })
  router.matcher = newRouter.matcher 
}

//4.向外共享路由示例对象
export default router